import { Injectable } from '@angular/core';
import { ComponentStore, OnStoreInit, tapResponse } from '@ngrx/component-store';
import { Subscription, switchMap, withLatestFrom } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { SellerService } from '../../http';
import { SellerInfo } from '../../models/seller-info';
import { map } from 'rxjs/operators';

export interface PdSellerState {
  clientHash?: string;
  sellerInfo?: SellerInfo;
}

@Injectable()
export class PdToNpdFlowStore extends ComponentStore<PdSellerState> implements OnStoreInit {
  public sellerInfo$ = this.select((s) => s.sellerInfo);
  public clientHash$ = this.select((s) => s.clientHash);
  public showForm$ = this.select((s) => s.clientHash && s.sellerInfo);

  private subs = new Subscription();

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly sellerService: SellerService,
  ) {
    super({
      clientHash: route.snapshot.params['hashedData'] as string,
    });
  }

  public ngrxOnStoreInit(): void {
    this.fetchSellerInfo();
  }

  public override ngOnDestroy(): void {
    this.subs.unsubscribe();
    super.ngOnDestroy();
  }

  private fetchSellerInfo = this.effect((trigger$) =>
    trigger$.pipe(
      withLatestFrom(this.route.params.pipe(map((params) => params['hashedData']))),
      switchMap(([_, clientId]) => this.sellerService.getSellerInfo(clientId)),
      tapResponse(
        (sellerInfo) => {
          if (!sellerInfo?.is_paid_directly) {
            void this.router.navigateByUrl('not-found');
          }
          this.patchState({ sellerInfo });
        },
        () => void this.router.navigateByUrl('not-found'),
      ),
    ),
  );
}
